import axios from 'axios'
import axiosRetry from 'axios-retry';



import { message } from 'ant-design-vue'
import router from '@/router/index'
import {publicConfig} from '@/publicConfig.js'

const commonRequest = axios.create({
  baseURL: publicConfig.requestUrl,
  maxRedirects: 0,
  timeout: 1000000
})
axiosRetry(commonRequest, { retries: 0 });

commonRequest.interceptors.request.use(config => {
  const skipAuth = ['/auth/captcha?key=888', '/auth/oauth/token']
  if (skipAuth.indexOf(config.url) === -1) {
    const token = localStorage.getItem('westToken')
    if (token) {
      config.headers.Authorization = 'bearer ' + token
    } else {
      router.push({ name: 'login' }, e => e, e => e)
    }
  }
  if (config.data && config.data.moveToQuery) {
    const params = config.data.params
    const query = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
    config.url = config.url + '?' + query
    config.data = undefined
  }
  return config
}, error => {
  return error
})
commonRequest.interceptors.response.use((res) => {
  if (res.data.state === 'failure') {
    message.error(res.data.description)
    return Promise.reject(new Error(res.data.description))
  } else {
    return res
  }
}, err => {
  const res = err.response
  if (res) {
    if (res.statusText === 'Unauthorized' || res.status === 401) {
      localStorage.removeItem('westToken')
      router.push({ name: 'login' })
    } else if (res.data) {
      message.error(res.data.message)
    }
  } else if (!axios.isCancel(err)) {
    message.error('网络错误')
  }
  return Promise.reject(err)
})
export default commonRequest
